import { gql } from '@apollo/client';

export const VehicleTypeFacetFragment = gql`
  fragment VehicleTypeFacetFragment on Facets {
    vehicleType {
      maxSeats
      doors {
        name
        displayName
      }
      vehicleType {
        displayName
        name
      }
    }
  }
`;
